<template>
  <v-row dense>
    <v-col v-if="!is_mobile_version" class="pt-0 pl-1 pr-1 pb-0">
      <!-- tool bar -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: 6px;"
          tile
      >
        <v-app-bar
          dense
          fixed
          color="elevation-1"
          style="margin-top:70px;"
        >
          <v-row no-gutters>
            <v-col class="d-flex pa-0">
              <v-autocomplete
                v-model="location_selected"
                :items="locations_list"
                item-text="name"
                item-value="_guid"
                label="All locations"
                dense
                solo
                clearable
                hide-details
                style="max-width:340px"
              >
                <template
                  slot="selection"
                  slot-scope="data"
                >
                  <div>
                    <div v-html="data.item.name" />
                  </div>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <!-- Divider and Header-->
                  <!-- Area item (group) -->
                  <template v-if="data.item._guid.type == TYPE_AREA">
                    <div class="select-drop-item-group__area">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                  <!-- Restaurant item (sub group) -->
                  <template v-else>
                    <div class="select-drop-item-sub_restaurant">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                </template>
              </v-autocomplete>

              <div style="margin-left:16px">
                <v-btn @click="onPreviosRange">
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>

                <v-menu
                  v-model="menu_date_picker"
                  transition="scale-transition"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on">
                      {{dateRangeText(date_range_selected)}}
                    </v-btn>
                  </template>

                  <v-card max-width="346px">
                    <v-date-picker
                      v-model="date_range_selected"
                      scrollable
                      actions
                      full-width
                      first-day-of-week="1"
                      range
                      :title-date-format="dateRangeText"
                      v-on:click:date="dateRangeSelect"
                      hide-details
                    ></v-date-picker>

                    <v-divider></v-divider>

                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn text @click="menu_date_picker = false">Cancel</v-btn>
                      <v-btn color="primary" text @click="menu_date_picker = false">Save</v-btn>
                    </v-card-actions> -->
                  </v-card>
                </v-menu>

                <v-btn @click="onNextRange">
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>

              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
                style="max-width:150px; margin-left:16px;"
              ></v-select>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>

          <div>
            <!-- <v-btn>
              <v-icon>mdi-export-variant</v-icon>&nbsp;Export
            </v-btn> -->
            <copy-shifts-modal :shiftList="shiftListDriverSearched" :intervalId="interval_selected_id" :dateRangeSelected="date_range_selected"></copy-shifts-modal>
            <!-- <v-btn>
              <v-icon>mdi-content-copy</v-icon>&nbsp;Copy Shifts
            </v-btn> -->
            <confirm-dialog @successClick="publishPeriodShifts" :messageText="'Publish ' + unpublishedShifts + ' Shift(s)?'">
              <v-btn
                  :loading="publishPeriodLoading"
                  class="blue lighten-3 ml-2"
                >
                <v-icon>mdi-post</v-icon>&nbsp;Publish Shifts&nbsp;[{{unpublishedShifts}}]
              </v-btn>
            </confirm-dialog>
            <v-menu offset-y left>
              <template v-slot:activator="{ on: on2, attrs }">
                <v-btn class="blue lighten-3 pl-1 pr-1" v-bind="attrs" v-on="on2">
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <confirm-dialog @successClick="unpublishPeriodShifts" :messageText="'Unpublish '+ publishedShifts +' shifts?'">
                  <v-list-item>
                    <v-list-item-title class="pointer"><v-icon left>mdi-eye-minus-outline</v-icon>Unpublish Shifts [{{publishedShifts}}]</v-list-item-title>
                  </v-list-item>
                </confirm-dialog>
                <confirm-dialog @successClick="removePeriodShifts" :messageText="'Remove unpublished '+ unpublishedShifts +' shifts?'">
                  <v-list-item>
                    <v-list-item-title class="pointer"><v-icon left>mdi-close</v-icon>Delete Unpublished Shifts [{{unpublishedShifts}}]</v-list-item-title>
                  </v-list-item>
                </confirm-dialog>
              </v-list>
            </v-menu>
          </div>
        </v-app-bar>

      </v-card>
      <!--/ tool bar -->
      <!-- body -->
      <div
        class="d-flex mb-auto"
        flat
        tile
      >
        <!-- toggle left panel -->
        <v-navigation-drawer
          permanent
          clipped
          left
          fixed
          width="256"
          :height="scroll_panel_height"
          style="margin-top:122px;"
        >
          <template v-slot:prepend>
            <v-row class="pt-1">
              <v-col>
                <v-card
                  class="d-flex justify-space-between"
                  flat
                  tile
                >
                  <v-text-field
                    v-model="search_driver"
                    label="Search"
                    hide-details
                    append-outer-icon="mdi-magnify"
                    dense
                    clearable
                  ></v-text-field>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        tile
                        class="dropdown-menu-activator"
                        :color="filter_empty_restaurants ? 'orange' : ''"
                        :disabled="!selected_driver"
                        v-on="on"
                        text
                        ><v-icon>mdi-filter</v-icon><v-icon>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item class="pointer">
                        <v-list-item-title @click="filter_empty_restaurants = !filter_empty_restaurants">
                          <template v-if="filter_empty_restaurants">
                            <v-icon color="orange">mdi-eye-minus-outline</v-icon>
                            Show restaurants with shifts
                          </template>
                          <template v-if="!filter_empty_restaurants">
                            <v-icon>mdi-eye-check</v-icon>
                            Show restaurants with shifts
                          </template>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <v-divider></v-divider>

          <v-list dense class="driver-list_leftpanel">
            <v-list-item
              v-for="(item, i) in driverListSearched"
              :key="i"
              @click="onChangeDriver(item)"
              :input-value="selected_driver && selected_driver.id == item.id"
              color="primary"
            >
              <!-- <v-list-item-icon class="driver-profile_icon">
                <img v-if="is_prod && item.photo_src" :src="appConfig.app_url + '/images/thumb/' + item.photo_src" class="driver-photo_src">
                <v-icon v-if="!is_prod || !item.photo_src">mdi-account</v-icon>
              </v-list-item-icon> -->
              <v-list-item-content>
                <v-list-item-title v-html="item.full_name"></v-list-item-title><v-list-item-title v-html="item.phone"></v-list-item-title>
                <v-list-item-subtitle v-if="item.id != -1 && driver_list_calc && driver_list_calc[item.id]">[{{driver_list_calc[item.id].shifts}}]&nbsp;{{driver_list_calc[item.id].hours | formatHours}}Hrs/£{{driver_list_calc[item.id].cost | formatFloat}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
        <!--/ toggle left panel -->
        <!-- right panel calendar -->
        <!-- headers -->
        <v-app-bar
          class="d-flex"
          color="white elevation-0"
          fixed
          height="auto"
          style="margin-top: 120px; margin-left:256px; z-index: 3"
          :style="'left: -' + bodyScrollLeft +'px'"
        >
          <v-card
            class="calendar-v-card-header"
            v-bind:class="{
              'v-card-header-day': interval_selected_id == INTERVAL_DAY,
              'v-card-header-week': interval_selected_id == INTERVAL_WEEK,
              'v-card-header-two-week': interval_selected_id == INTERVAL_TWO_WEEK,
              'v-card-header-month': interval_selected_id == INTERVAL_MONTH
            }"
            color="elevation-0"
            >
            <v-row
              no-gutters
            >
              <v-col
                v-for="item in period_list"
                :key="item.date"
                class="text-center"
              >
                {{ item.date | headerData }}
                <v-menu offset-y left>
                  <template v-slot:activator="{ on }">
                    <v-btn class="pl-0 pr-0" v-on="on" x-small :disabled="!location_selected || (selected_driver && isDriverUnavailableOrHasShift(selected_driver, item.date))" :class="{ 'grey--text': selected_driver && isDriverUnavailableOrHasShift(selected_driver, item.date) }">
                      <v-icon>mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card style="max-height: 300px; width: 350px; overflow-y: auto;">
                    <!-- Filter Toggle Button -->
                    <v-card-actions class="justify-end">
                      <v-btn icon @click.stop="showOnlyUnavailable = !showOnlyUnavailable">
                        <v-icon :class="{ 'green--text': showOnlyUnavailable }">mdi-filter</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <v-list v-if="filteredDriverList(item.driver_working_time)" dense>
                      <v-list-item
                        v-for="working_time in filteredDriverList(item.driver_working_time)"
                        :key="working_time.driver.id"
                      >
                        <v-list-item-avatar class="mt-0 mb-0">
                          <img v-if="working_time.driver.photo_src" :src="appConfig.app_url + '/images/thumb/' + working_time.driver.photo_src" class="working_time.driver-photo_src">
                          <v-icon v-else>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="pt-0 pb-0">
                          <v-list-item-title v-html="working_time.driver.full_name"></v-list-item-title>
                          <!-- Display working days/availability -->
                          <v-list-item-subtitle v-for="(working_day, k) in working_time.working_days" :key="k" :class="{ 'red--text': working_day === 'Driver unavailable','orange--text': working_day !== 'Driver unavailable' }">
                            {{working_day}}
                          </v-list-item-subtitle>
                          <!-- Display shift details if available -->
                          <v-list-item-subtitle
                            v-if="working_time.shift_details && working_time.shift_details.length > 0"
                            class="font-weight-medium mt-1">
                            Assigned Shifts:
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-for="(shift, s) in working_time.shift_details" :key="'shift-' + s"
                            class="green--text">
                            {{ shift }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-card-text v-else-if="showOnlyUnavailable" class="text-center green--text">
    All Drivers Available
  </v-card-text>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
          </v-card>
        </v-app-bar>
        <!--/ headers -->
        <v-card
          v-if="!showLoader"
          color="elevation-1"
          class="right-panel-calendar"
          :height="scroll_panel_height - 79"
          v-on:scroll.self.passive="onScrollPanel"
        >
          <!-- body -->
          <v-card
            class="calendar-v-card-body"
            v-bind:class="{
              'v-card-day': interval_selected_id == INTERVAL_DAY,
              'v-card-week': interval_selected_id == INTERVAL_WEEK,
              'v-card-two-week': interval_selected_id == INTERVAL_TWO_WEEK,
              'v-card-month': interval_selected_id == INTERVAL_MONTH
            }"
            color="elevation-0"
            v-for="(restaurant_item, i) in restaurantListSearched"
            :key="i"
            no-gutters
            >
            <v-card
              color="grey lighten-2"
            >
              <v-col>{{restaurant_item.name}}</v-col>
            </v-card>

            <v-row align="stretch">
              <v-col
                v-for="period_item in period_list"
                :key="period_item.date"
                class="text-center pl-0 pr-0"
              >
                <v-hover
                  v-slot:default="{ hover:hover_col }"
                  open-delay="100"
                  style="height:100%;"
                  class="ml-2 mr-2"
                >
                  <div><!-- v-hover require single child element -->
                    <v-btn
                        outlined
                        color="grey"
                        small
                        @click="showNewShift(restaurant_item.id, period_item.date, period_item.restaurant_shifts)":disabled="selected_driver && isDriverUnavailableOrHasShift(selected_driver.id, period_item.date)"
                    ><v-icon left>mdi-plus</v-icon>Add
                    </v-btn>

                      <v-tooltip bottom nudge-left="52" nudge-bottom="4" v-if="shift_to_copy && (hover_col || period_item.localLoading)">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            outlined
                            small
                            color="grey"
                            :loading="period_item.localLoading"
                            @click="pasteShift(restaurant_item, period_item)"
                          >
                            <!-- v-if="shift_to_copy && (colHover || shift_to_copy.localLoading)" -->
                            <v-icon left>mdi-content-paste</v-icon>Paste
                          </v-btn>
                        </template>
                        <span>Hold the <span class="yellow--text">&quot;Shift&quot;</span> key to continue copying multiple times</span>
                      </v-tooltip>

                      <v-menu v-for="shift in period_item.restaurant_shifts[restaurant_item.id]" :key="shift.date">
                          <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                tile
                                small
                                block
                                class="shift-button_item"
                                v-bind:class="{
                                  'light-green lighten-3': shift.status == STATUS_PUBLICATED && !shift.status_assigned == STATUS_STALE,
                                  'yellow lighten-3': shift.status_assigned == STATUS_FREE || shift.status_assigned == STATUS_STALE, // STATUS_FREE will setup on server
                                }"
                                :loading="shift.localLoading"
                              >
                                <div>
                                  ({{shift.start_time | formatTime}} - {{shift.finish_time | formatTime}})
                                  <v-tooltip bottom nudge-left="52" nudge-bottom="10">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="shift.comment && on">
                                        <v-icon style="font-size: 14px;" v-if="shift.status == STATUS_PUBLICATED">mdi-eye</v-icon>
                                        <v-icon style="font-size: 14px; color: red;" v-if="shift.status == STATUS_NEW">mdi-eye-off</v-icon>
                                        <v-icon style="font-size: 14px; color: gray;" v-if="shift.status == STATUS_DRAFT">mdi-eye-off</v-icon>
                                      </span>
                                    </template>
                                    <span v-if="shift.comment">{{shift.comment}}</span>
                                    <!-- <span v-if="!shift.comment">(empty)</span> -->
                                  </v-tooltip>
                                  <v-tooltip bottom nudge-left="52" nudge-bottom="10" v-if="shift.timesheet != null">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-icon style="font-size: 14px; color: #FF5722;">mdi-lock</v-icon>
                                      </span>
                                    </template>
                                    <span>Timesheet exists by this shift</span>
                                  </v-tooltip>
                                  <div v-if="shift.status_assigned == STATUS_STALE">
                                    <v-tooltip bottom nudge-left="52" nudge-bottom="10">
                                      <template v-slot:activator="{ on }">
                                        <span v-on="shift.comment && on">
                                          Open shift <v-icon style="font-size: 14px; color: red;">mdi-close</v-icon>
                                        </span>
                                      </template>
                                      <span v-if="shift.comment">Rejected by: {{getDriverFullName(shift)}}</span>
                                    </v-tooltip>
                                  </div>
                                  <div v-if="shift.status_assigned != STATUS_STALE">
                                    {{getDriverFullName(shift)}}
                                  </div>
                                </div>
                              </v-btn>
                          </template>
                          <v-list>
                              <v-list-item @click="copyShift(shift)">
                                <v-list-item-title>Copy</v-list-item-title>
                              </v-list-item>
                              <edit-shift-modal :shiftItem="shift" :shiftList="shift_list"></edit-shift-modal>

                              <v-list-item @click="removeShift(shift)" v-if="shift.timesheet == null">
                                <v-list-item-title>Remove</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="changeShiftStatus(shift, STATUS_NEW)" v-if="shift.status == STATUS_PUBLICATED">
                                <v-list-item-title>Unpublish</v-list-item-title>
                              </v-list-item>
                              <cancel-shift-modal v-if="(shift.status == STATUS_PUBLICATED && shift.status_assigned == STATUS_ASSIGNED)" :shiftItem="shift" :shiftList="shift_list" ></cancel-shift-modal>

                              <confirm-dialog v-if="shift.status == STATUS_NEW && (shift.status_assigned == STATUS_FREE || shift.status_assigned == STATUS_STALE)" @successClick="(opt) => changeShiftStatus(shift, STATUS_PUBLICATED, opt)" :messageText="'Notify drivers?'" :pushDrivers="20">
                                <div class="v-list-item v-list-item--link theme--light">Publish</div>
                              </confirm-dialog>

                              <v-list-item v-if="shift.status == STATUS_NEW && (shift.status_assigned != STATUS_FREE && shift.status_assigned != STATUS_STALE)" @click="changeShiftStatus(shift, STATUS_PUBLICATED)">
                                <v-list-item-title>Publish</v-list-item-title>
                              </v-list-item>
                              <!-- <new-driver-modal :driverList="driverList"></new-driver-modal>
                              <new-driver-half-board-modal :driverList="driverList"></new-driver-half-board-modal> -->
                          </v-list>
                      </v-menu>
                  </div>
                </v-hover>
              </v-col>
            </v-row>
          </v-card>
          <!--/ body -->
        </v-card>
        <!--/ right panel calendar -->
      </div>
      <!--/ body -->
      <!-- tool bar bottom -->
      <div class="ml-16 pl-16 mt-9" v-if="showLoader">
        <v-skeleton-loader
          class="ml-16 pl-16"
          v-bind="attrs"
          type="list-item-three-line, list-item-three-line, list-item-three-line, list-item-three-line"
        />
      </div>
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: -5px;"
          tile
      >
        <v-app-bar
          fixed
          bottom
          height="36px"
          color="elevation-1 tool-bar__totals-panel">
          <v-spacer></v-spacer>
          <div>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.published}}</div>
              <div class="shift-total_label">Published Shifts</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.unpublished}}</div>
              <div class="shift-total_label">Unpublished Shifts</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.draft}}</div>
              <div class="shift-total_label">Draft Shifts</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.free}}</div>
              <div class="shift-total_label">Open Shifts</div>
            </v-btn>
          </div>
          <v-spacer></v-spacer>

          <div>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.total_shifts}}</div>
              <div class="shift-total_label">Total Shifts</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.filled_hours | formatHours}}</div>
              <div class="shift-total_label">Filled Hours</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.estimated_cost | formatFloat}}</div>
              <div class="shift-total_label">Est. Cost</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.expected_sales | formatFloat}}</div>
              <div class="shift-total_label">Expected Sales</div>
            </v-btn>
          </div>
        </v-app-bar>
      </v-card>
      <!--/ tool bar bottom -->
    </v-col>
    <!-- mobile version -->
    <v-col v-if="is_mobile_version">
      <!-- tool bar -->
      <v-card
        color="grey lighten-4"
        flat
        style="margin-bottom: 6px;"
        tile
      >
        <v-toolbar dense color="elevation-1 tool-bar__actions-panel header-btn-panel header-btn-panel-mobile" height="40">
          <v-row
            class="d-flex mb-auto"
            no-gutters
          >
            <div class="menu-date__picker-mobile">
              <v-btn @click="onPreviosRange">
                <v-icon>mdi-menu-left</v-icon>
              </v-btn>

              <v-menu
                v-model="menu_date_picker"
                transition="scale-transition"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on">
                    {{dateRangeText(date_range_selected)}}
                  </v-btn>
                </template>

                <v-card max-width="346px">
                  <v-date-picker
                    v-model="date_range_selected"
                    scrollable
                    actions
                    full-width
                    first-day-of-week="1"
                    range
                    :title-date-format="dateRangeText"
                    v-on:click:date="dateRangeSelect"
                  ></v-date-picker>

                  <v-divider></v-divider>
                </v-card>
              </v-menu>

              <v-btn @click="onNextRange">
                <v-icon>mdi-menu-right</v-icon>
              </v-btn>
            </div>

            <div class="menu-interval-changer-mobile">
              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
              ></v-select>
            </div>

            <div class="menu-restaurant-changer-mobile">
               <v-autocomplete
                v-model="location_mobile_selected"
                :items="locations_list"
                @change="onSelectRestaurantMobile"
                item-text="name"
                item-value="_guid"
                label="All locations"
                dense
                solo
                hide-details
                style="max-width:340px"
              >
                <template
                  slot="selection"
                  slot-scope="data"
                >
                  <div>
                    <div v-html="data.item.name" />
                  </div>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <!-- Divider and Header-->
                  <!-- Area item (group) -->
                  <template v-if="data.item._guid.type == TYPE_AREA">
                    <div class="select-drop-item-group__area">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                  <!-- Restaurant item (sub group) -->
                  <template v-else>
                    <div class="select-drop-item-sub_restaurant">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                </template>
              </v-autocomplete>
            </div>
          </v-row>

          <v-row>
            <v-col>
              <copy-shifts-modal :shiftList="shiftListSearched" :intervalId="interval_selected_id" :dateRangeSelected="date_range_selected"></copy-shifts-modal>
              <v-btn
                  @click="publishPeriodShifts"
                  :loading="publishPeriodLoading"
                  class="blue lighten-3 ml-1"
                >
                <v-icon>mdi-post</v-icon>&nbsp;Publish shifts&nbsp;[{{unpublishedShifts}}]
              </v-btn>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card>
      <!--/ tool bar -->
      <!-- body -->
      <div
        class="d-flex mb-auto"
        flat
        tile
      >
        <!-- right panel calendar -->
        <v-card
          color="elevation-0"
          class="right-panel-calendar-mobile"
        >
          <v-card
            v-if="!restaurant_item_mobile_selected"
            class="calendar-v-card-header"
            color="elevation-1"
          >
            <v-row>
              <v-col class="text-center">
                No restaurant selected
              </v-col>
            </v-row>
          </v-card>

          <v-card
            v-if="restaurant_item_mobile_selected"
            class="calendar-v-card-header"
            color="elevation-1"
          >
            <v-row
              v-for="period_item in period_list"
              :key="period_item.date"
            >
              <v-col class="text-center">
                <v-card
                  class="calendar-v-card-body"
                  color="elevation-0"
                >
                  <v-card
                    color="grey lighten-2"
                  >
                    <!-- <v-col>{{restaurant_item_mobile_selected.name}}</v-col> -->
                    <v-col>{{ period_item.date | moment }}</v-col>
                  </v-card>
                  <v-row align="stretch">
                    <v-col class="text-center">
                      <v-btn
                          outlined
                          color="grey"
                          small
                          @click="showNewShift(restaurant_item_mobile_selected.id, period_item.date, period_item.restaurant_shifts)"
                      ><v-icon left>mdi-plus</v-icon>Add
                      </v-btn>

                      <v-btn
                        outlined
                        small
                        color="grey"
                        v-if="restaurant_item_mobile_selected && shift_to_copy"
                        :loading="period_list_loading[period_item.date]"
                        @click="pasteShift(restaurant_item_mobile_selected, period_item)"
                      >
                        <v-icon left>mdi-content-paste</v-icon>Paste
                      </v-btn>

                      <v-menu v-for="shift in period_item.restaurant_shifts[restaurant_item_mobile_selected.id]" :key="shift.date">
                          <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                tile
                                small
                                block
                                class="shift-button_item shift-button_item-fix_height"
                                v-bind:class="{
                                  'light-green lighten-3': shift.status == STATUS_PUBLICATED && !shift.status_assigned == STATUS_STALE,
                                  'yellow lighten-3': shift.status_assigned == STATUS_FREE, // STATUS_FREE wiil setup on server
                                  'red darken-3': shift.status_assigned == STATUS_STALE,
                                }"
                                :loading="shift.localLoading"
                              >
                                <div>
                                  <v-tooltip left nudge-left="50">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        ({{shift.start_time | formatTime}} - {{shift.finish_time | formatTime}})
                                        <v-icon style="font-size: 14px;" v-if="shift.status == STATUS_PUBLICATED">mdi-eye</v-icon>
                                        <v-icon style="font-size: 14px; color: red;" v-if="shift.status == STATUS_NEW">mdi-eye-off</v-icon>
                                        <v-icon style="font-size: 14px; color: gray;" v-if="shift.status == STATUS_DRAFT">mdi-eye-off</v-icon>
                                      </span>
                                    </template>
                                    <span v-if="shift.comment">{{shift.comment}}</span>
                                    <span v-if="!shift.comment">(empty)</span>
                                  </v-tooltip>
                                  <v-tooltip bottom nudge-left="52" nudge-bottom="10" v-if="shift.timesheet != null">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-icon style="font-size: 14px; color: #FF5722;">mdi-lock</v-icon>
                                      </span>
                                    </template>
                                    <span>Timesheet exists by this shift</span>
                                  </v-tooltip>
                                  <div>
                                    {{getDriverFullName(shift)}}<span v-if="getDriverPhone(shift)">, phone: {{getDriverPhone(shift)}}</span>
                                  </div>
                                </div>
                              </v-btn>
                          </template>
                          <v-list>
                              <v-list-item @click="copyShift(shift)">
                                <v-list-item-title>Copy</v-list-item-title>
                              </v-list-item>
                              <edit-shift-modal :shiftItem="shift" :shiftList="shift_list"></edit-shift-modal>
                              <v-list-item @click="removeShift(shift)" v-if="shift.timesheet == null">
                                <v-list-item-title>Remove</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="changeShiftStatus(shift, STATUS_NEW)" v-if="shift.status == STATUS_PUBLICATED">
                                <v-list-item-title>Unpublish</v-list-item-title>
                              </v-list-item>
                              <cancel-shift-modal v-if="(shift.status == STATUS_PUBLICATED && shift.status_assigned == STATUS_ASSIGNED)" :shiftItem="shift" :shiftList="shift_list" ></cancel-shift-modal>
                              <confirm-dialog v-if="shift.status == STATUS_NEW && (shift.status_assigned == STATUS_FREE || shift.status_assigned == STATUS_STALE)" @successClick="(opt) => changeShiftStatus(shift, STATUS_PUBLICATED, opt)" :messageText="'Notify drivers?'" :pushDrivers="20">
                                <div class="v-list-item v-list-item--link theme--light">Publish</div>
                              </confirm-dialog>

                              <v-list-item v-if="shift.status == STATUS_NEW && (shift.status_assigned != STATUS_FREE && shift.status_assigned != STATUS_STALE)" @click="changeShiftStatus(shift, STATUS_PUBLICATED)">
                                <v-list-item-title>Publish</v-list-item-title>
                              </v-list-item>
                          </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
        <!--/ right panel calendar -->
      </div>
      <!--/ body -->
    </v-col>
    <!--/ mobile version -->

    <new-shift-modal
        :restaurantItemId="restaurant_item_id"
        :periodDate="period_item_date"
        :shiftList="shift_list"
        :show-modal="showNewShiftDialog"
        @closeDialog="showNewShiftDialog = false"
    ></new-shift-modal>
  </v-row>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import * as _ from 'lodash';
import { mapGetters } from 'vuex';
import { TYPE_AREA, TYPE_RESTAURANT } from '../../store/areas';
import { DATE_RANGE_HELPERS,
         STATUS_NEW, STATUS_PUBLICATED, STATUS_DRAFT,
         INTERVAL_DAY, INTERVAL_WEEK, INTERVAL_TWO_WEEK, INTERVAL_MONTH,
         STATUS_FREE, STATUS_STALE, STATUS_ASSIGNED
       } from '../../store/shifts';
import ConfirmDialog from "./ConfirmDialog";

const IS_HOLIDAY = 10;
// const IS_REGULAR_DAY = 20;
const STATUS_RESTAURANT_ACTIVE = 10;

export default {
  name: "Schedule",
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  props: ['restaurantId'],
  data: () => ({
    is_prod: process.env.NODE_ENV == 'production', // fix high load unvailable images on develop server
    // panels
    scroll_panel_height: window.innerHeight - 122,
    // const list for template
    TYPE_AREA: TYPE_AREA,
    TYPE_RESTAURANT: TYPE_RESTAURANT,
    STATUS_NEW: STATUS_NEW,
    STATUS_PUBLICATED: STATUS_PUBLICATED,
    STATUS_DRAFT: STATUS_DRAFT,
    STATUS_FREE: STATUS_FREE,
    STATUS_STALE: STATUS_STALE,
    STATUS_ASSIGNED: STATUS_ASSIGNED,
    INTERVAL_DAY: INTERVAL_DAY,
    INTERVAL_WEEK: INTERVAL_WEEK,
    INTERVAL_TWO_WEEK: INTERVAL_TWO_WEEK,
    INTERVAL_MONTH: INTERVAL_MONTH,
    interval_list: [
      { id: INTERVAL_DAY, name: 'Day', $isDisabled: true },
      { id: INTERVAL_WEEK, name: 'Week' },
      { id: INTERVAL_TWO_WEEK, name: '2-Week' },
      { id: INTERVAL_MONTH, name: 'Month' },
    ],
    // ---
    date_range_selected: null,
    menu_date_picker: false,
    showOnlyUnavailable: false,
    thisRestaurantId: null,
    localLoading: false,
    publishPeriodLoading: false,
    restaurant_selected_index: 0,
    location_selected: void 0, // _guid
    interval_selected_id: INTERVAL_WEEK, // default week
    selected_driver: void 0,
    search_driver: '',
    shift_to_copy: void 0,
    driver_list_calc: {}, // cached property
    filter_empty_restaurants: false,
    totals: {
      total_shifts: 0,
      filled_hours: 0,
      estimated_cost: 0,
      expected_sales: 0,
      published: 0,
      draft: 0,
      unpublished: 0,
      free: 0,
    },
    restaurant_item_id: void 0,
    period_item_date: void 0,
    showNewShiftDialog: false,
    showLoader: false,
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
    bodyScrollLeft: 0,
    is_mobile_version: false,
    location_mobile_selected: void 0, // _guid
    restaurant_item_mobile_selected: void 0,
    period_list_loading: {},
  }),
  computed: {
    ...mapGetters([
      'areas',
      'locations',
      'restaurants',
      'drivers'
    ]),
      //Other computed properties
    locations_list() {
      return this.locations;
      // return areas;
    },
    restaurant_list() {
        let restaurants = _.filter(this.restaurants, o => o.status == STATUS_RESTAURANT_ACTIVE)
        return restaurants;
    },
    restaurantListOnlyLocSearched() {
      let result = this.restaurant_list;

      if (this.$data.location_selected) {
        switch(this.$data.location_selected.type) {
          case TYPE_AREA:
            // filter by list of restaurants
            result = _.filter(result, p => p.area_id == this.$data.location_selected.id);
            break;
          case TYPE_RESTAURANT:
            // filter by one restaurant
            result = [
              _.find(result, p => p.id == this.$data.location_selected.id)
            ];
        }
      }
      return result
    },
    restaurantListSearched() {
      let result = this.restaurant_list;

      if (this.$data.location_selected) {
        switch(this.$data.location_selected.type) {
          case TYPE_AREA:
            // filter by list of restaurants
            result = _.filter(result, p => p.area_id == this.$data.location_selected.id);
            break;
          case TYPE_RESTAURANT:
          // filter by one restaurant
          result = [
            _.find(result, p => p.id == this.$data.location_selected.id)
          ];
        }
      }

      if (this.selected_driver) { // only if driver selected
        // filter slected driver areas
        if (!_.isEmpty(this.selected_driver.area_ids)) {
          let driver_area_ids = _.map(this.selected_driver.area_ids, p => p.area_id);
          result = _.filter(result, p => driver_area_ids.indexOf(p.area_id) !== -1);
        }

        // filter slected driver restaurants
        if (!_.isEmpty(this.selected_driver.restaurant_ids)) {
          let driver_restaurant_ids = _.map(this.selected_driver.restaurant_ids, p => p.restaurant_id);
          result = _.filter(result, p => driver_restaurant_ids.indexOf(p.id) !== -1);
        }

        // filter, if restaurant do not have shifts then hide it
        if (this.filter_empty_restaurants) {
          result = _.filter(result, p => !!_.find(this.shift_list, s => {
            if (s.restaurant_id != p.id) return false;

            if (this.selected_driver.id == -2) {
              return s.status_assigned == STATUS_FREE || s.status_assigned == STATUS_STALE;
            }

            return this.selected_driver.id == s.driver_id;
          }));
        }
      }

      return result;
    },
    driver_list() {
      return this.drivers;
    },
    driverListSearched() {
      let driver_list = _.map(this.driver_list, p => p); // copy array, - be modifed

      // filter by search
      if (this.$data.search_driver) {
        driver_list = _.filter(driver_list, p => p.full_name.toLowerCase().indexOf(this.$data.search_driver) !== -1)
      }

      // filter by selected area or selected restaurant area
      if (this.$data.location_selected) {
        // filter by aread ids
        let area_ids = _.map(this.restaurantListOnlyLocSearched, p => +p.area_id);
        driver_list = _.filter(driver_list, driver => {
          let driver_area_ids = _.map(driver.area_ids, p => p.area_id);
          return ( _.intersection(area_ids, driver_area_ids).length > 0)
        });

        // filter by restaurants, check if driver assigned to other restaurant
        // if (this.$data.location_selected.type == TYPE_RESTAURANT) {
        //   driver_list = _.filter(driver_list, driver => {
        //     if (driver.restaurant_ids.length == 0) {
        //       return true; // driver not assigned to restaurant
        //     }
        //
        //     let driver_restaurant_ids = _.map(driver.restaurant_ids, p => p.restaurant_id);
        //     return driver_restaurant_ids.indexOf(this.$data.location_selected.id) !== -1;
        //   });
        // }
      }

      // add free shifts filter
      if(driver_list.length == 0 || (driver_list.length > 0 && driver_list[0].id !== null)) {
        let all_drivers = {
            id: -1,
            full_name: 'All drivers [' + driver_list.length + ']',
        };

        let free_driver = {
            id: -2,
            full_name: "Open shifts",
        };

        driver_list.unshift(free_driver);
        driver_list.unshift(all_drivers);
      }

      return driver_list;
    },
    shift_list() {
      return this.$store.getters.shifts;
    },
    shiftListSearched() {
      let shift_list = this.shift_list;
      //-- apply shift_list filters:
      //-- filter by `location_selected`
      if (this.$data.location_selected !== void 0) {
        let area_id,
            restaurant_ids = _.map(this.restaurantListSearched, p => +p.id);
        if (this.location_selected.type === 10) {
          area_id = _.uniq(_.map(this.restaurantListSearched, p => +p.area_id))
          if (!area_id || !area_id.length) area_id = this.location_selected.id
          area_id = area_id.length ? area_id[0] : area_id
        } else {
          area_id = _.uniq(_.map(this.restaurantListSearched, p => +p.id))
          if (!area_id || !area_id.length) area_id = this.location_selected.id
          if (area_id.length) area_id = area_id[0]
        }

        if (this.location_selected.type !== 10) shift_list = _.filter(shift_list, p => area_id == p.restaurant_id );
        else shift_list = _.filter(shift_list, p => area_id == this.areaIdFromRestaurantId(+p.restaurant_id) );
      }

      // filter draft
      shift_list = _.filter(shift_list, p => p.status != STATUS_DRAFT);
      return shift_list;
    },
    shiftListDriverSearched() {
      let shift_list = this.shiftListSearched;
      //-- filter by `selected_driver`
      if (this.$data.selected_driver !== void 0) {
        if (this.$data.selected_driver.id == -2) { // free shifts
          shift_list = _.filter(shift_list, p => p.status_assigned == STATUS_FREE || p.status_assigned == STATUS_STALE);
        } else {
          shift_list = _.filter(shift_list, p => p.driver_id == this.$data.selected_driver.id);
        }
      }

      return shift_list;
    },
    area_list() {
      return this.$store.getters.areas;
    },
    period_list() {
      if (!this.$data.date_range_selected) {
        return;
      }
      // Filter driver list based on location_selected
      let driver_list = this.driver_list;
      if (this.$data.location_selected) {
        let area_ids = _.map(this.restaurantListOnlyLocSearched, p => +p.area_id);
        driver_list = _.filter(driver_list, driver => {
          let driver_area_ids = _.map(driver.area_ids || [], p => p.area_id);
          return _.intersection(area_ids, driver_area_ids).length > 0;
        });
      }


      let shift_list = this.shiftListDriverSearched;
      // build period list
      let start_date_iterator = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      let i = 0;
      let period_list = [];
      while(start_date_iterator.format("YYYY-MM-DD") <= this.$data.date_range_selected[1]) {
        if (i == 31) {
          alert('Invalid date range: ' + this.$data.date_range_selected[0] + ' ~ ' + this.$data.date_range_selected[1]);
          break;
        }

        let period_date = start_date_iterator.format("YYYY-MM-DD");
        // cache shifts for better perfomance
        let restaurant_shifts = _.groupBy(
          _.filter(shift_list, p => {
            return p.period_date == period_date;
          }),
          'restaurant_id'
        );

        let driver_working_time = driver_list.map(driver => {
          let working_days = this.getDriverWorkingDay(driver, period_date);
          let shift_details = this.checkDriverShifts(driver.id, period_date);

          return {
            driver: driver,
            working_days: working_days.length > 0
              ? _.map(working_days, p => {
                if (p.holiday == IS_HOLIDAY) {
                  return 'Driver unavailable';
                }
                return 'Unavailable time: ' + moment(p.start_at, "HH:mm").format('HH:mm') + '-' + moment(p.stop_at, "HH:mm").format('HH:mm');
              })
              : [''],
            shift_details: shift_details
          };
        });

        let period = {
          date: period_date,
          restaurant_shifts: restaurant_shifts,
          driver_working_time: driver_working_time,
        };

        period_list.push(period);

        // incress date counter
        start_date_iterator.add(1, 'days');
        i++;
      }

      return period_list;
    },
    unpublishedShifts() {
      let unpublished_shifts = _.filter(this.shiftListDriverSearched, p => p.status == STATUS_NEW);
      return unpublished_shifts.length;
    },
    publishedShifts() {
      let unpublished_shifts = _.filter(this.shiftListDriverSearched, p => p.status == STATUS_PUBLICATED);
      return unpublished_shifts.length;
    },
    freeShifts() {
      let free_shifts = _.filter(this.shiftListDriverSearched, p => !p.driver_id);
      return free_shifts.length;
    }
  },
  watch: {
    shiftListSearched: function(shift_list_new) {
      // calc totals
      this.$data.totals.total_shifts = shift_list_new.length;
      this.$data.totals.filled_hours = 0;
      this.$data.totals.estimated_cost = 0;
      this.$data.totals.expected_sales = 0;
      this.$data.totals.published = 0;
      this.$data.totals.draft = 0;
      this.$data.totals.unpublished = 0;
      this.$data.totals.free = 0;

      let shift_total_hours_tmp = []; // cached array
      for (let j = 0; j < shift_list_new.length; j++) {
        shift_total_hours_tmp[j] = this.getShiftHours(shift_list_new[j]);
        this.$data.totals.filled_hours += shift_total_hours_tmp[j];
        if (shift_list_new[j].status == STATUS_PUBLICATED) {
          this.$data.totals.estimated_cost += +shift_list_new[j].cost_total;
          this.$data.totals.published += 1;
        } else if(shift_list_new[j].status == STATUS_DRAFT) {
          this.$data.totals.draft += 1;
        } else { // STATUS_NEW
          this.$data.totals.unpublished += 1;
        }
        if (shift_list_new[j].status_assigned == STATUS_FREE || shift_list_new[j].status_assigned == STATUS_STALE) { // !shift_list_new[j].driver_id
          this.$data.totals.free += 1;
        }
        // STATUS_PUBLICATED || STATUS_NEW
        this.$data.totals.expected_sales += +shift_list_new[j].cost_total;
      }

      // calc driver totals
      let driver_list = this.driverListSearched;
      // this.$data.driver_list_calc = {};
      for (let i = 0; i < driver_list.length; i++) {
        let driver_calc_item = {
          cost: 0,
          hours: 0,
          shifts: 0,
        };

        for (let j = 0; j < shift_list_new.length; j++) {
          if (
                 (shift_list_new[j].driver_id == driver_list[i].id && shift_list_new[j].status_assigned != STATUS_STALE) // assigned
              || ((shift_list_new[j].driver_id == null || shift_list_new[j].status_assigned == STATUS_STALE) && driver_list[i].id == -2) // open shifts or rejected shifts
          ) {
            driver_calc_item.cost = +driver_calc_item.cost + +shift_list_new[j].cost_total;
            //! cost_bonus and const_fuel_bonus already attached into cost_total
            // if (shift_list_new[j].cost_bonus) {
            //   driver_calc_item.cost = driver_calc_item.cost + +shift_list_new[j].cost_bonus;
            // }
            // if (shift_list_new[j].const_fuel_bonus) {
            //   driver_calc_item.cost = driver_calc_item.cost + +shift_list_new[j].const_fuel_bonus;
            // }
            //! cost_extra_bonus already attached into cost_total
            driver_calc_item.hours = +driver_calc_item.hours + shift_total_hours_tmp[j];
            driver_calc_item.shifts = driver_calc_item.shifts + 1;
          }
        }
        this.$data.driver_list_calc[driver_list[i].id] = driver_calc_item;
      }
    }
  },
  mounted() {
    // scroll panel height
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });

    // moment.locale(['ru', 'en']);
    // aync load data
    this.showLoader = true;
    Promise.all([
      this.$store.dispatch('fetchLocations'),
      this.$store.dispatch('fetchDrivers'),
      // this.$store.dispatch('fetchRestaurants'), //? double loadin
      // this.$store.dispatch('fetchAreas') //? double loadin
    ]).then(() => {
      // this.showLoader = false; // -> dateRangeSelect
      // check is redirrected from restaurant's page
      let restaurant_id = localStorage.getItem('redirrected_from_restaurants');
      localStorage.setItem('redirrected_from_restaurants', void 0); // clear
      if (restaurant_id && restaurant_id !== "undefined") {
         let location_selected = _.find(this.locations_list, p => +p._guid.id == +restaurant_id && p._guid.type == TYPE_RESTAURANT);
         if (location_selected) {
           this.$data.location_selected = location_selected._guid;
         }
      }

      let current_date = moment();
      // this.$data.interval_selected_id = this.$data.interval_list[1].id; // 1 - one week
      this.$data.date_range_selected = [current_date.startOf('isoWeek').format('YYYY-MM-DD'), null];

      this.dateRangeSelect();
    });

    if (!this.restaurant_item_mobile_selected && this.locations_list.length > 0) {
      let item = _.find(this.locations_list, p => p._guid.type == TYPE_RESTAURANT);
      this.location_mobile_selected = item;
      this.onSelectRestaurantMobile(this.location_mobile_selected._guid);
    }

    this.$store.dispatch('user/fetchUsers'); // EditShiftModal
    this.$store.dispatch('fetchRestaurateurs'); // EditShiftModal
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  created(){
    // detect mobile version
    let check = false;
    // eslint-disable-next-line
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

    this.is_mobile_version = check;

    if (this.restaurantId) {
        this.thisRestaurantId = this.restaurantId
    }
  },
  methods: {
    filteredDriverList(driverWorkingTime) {
  if (this.showOnlyUnavailable) {
    const unavailableDrivers = driverWorkingTime.filter(working_time =>
      working_time.working_days.includes('Driver unavailable') ||
      working_time.working_days.some(day => day.startsWith('Unavailable time:'))
    );
    return unavailableDrivers.length > 0 ? unavailableDrivers : null;
  }
  return driverWorkingTime;
},
    checkDriverShifts(driverId, periodDate) {
      // Find shifts for the specific driver on the given period date
      const driverShifts = this.shift_list.filter(shift =>
        shift.driver_id === driverId &&
        shift.period_date === periodDate
      );

      if (driverShifts.length === 0) {
        return [];
      }

      // Format shift details with just restaurant name and times
      return driverShifts.map(shift => {
        const restaurant = this.restaurant_list.find(r => r.id === shift.restaurant_id);
        const restaurantName = restaurant ? restaurant.name : "Unknown Restaurant";

        return `${restaurantName}: ${moment(shift.start_time, "HH:mm").format('HH:mm')} - ${moment(shift.finish_time, "HH:mm").format('HH:mm')}`;
      });
    },
    isDriverUnavailableOrHasShift(driverId, periodDate) {
      // Check if driver is unavailable
      const workingDays = this.getDriverWorkingDay(driverId,periodDate);
      const isUnavailable = workingDays.some(day => day.holiday == IS_HOLIDAY);
      // Check if driver has shifts
      const hasShift = this.shift_list.some(shift =>
        shift.driver_id === driverId.id &&
        shift.period_date === periodDate
      );
      return isUnavailable || hasShift;
    },
    areaIdFromRestaurantId(id) {
      let area = null
      this.locations_list.forEach(loc => {
        if (loc.area_id) {
          if (id == loc.id) area = loc.area_id
        } else {
          if (id == loc.id) area = id
        }
      })
      return area
    },
    showNewShift(restaurant_item_id, period_item_date) {
        this.restaurant_item_id = restaurant_item_id;
        this.period_item_date = period_item_date;

        this.showNewShiftDialog = true; //! it must be last
    },
    onResize() {
      this.scroll_panel_height = window.innerHeight - 122;
    },
    dateRangeSelect() {
      this.showLoader = true
      this.$data.date_range_selected = this.dayToRange(this.$data.date_range_selected[0], this.$data.interval_selected_id);

      // fetch shifts from server
      this.$store.dispatch('fetchShifts', {
        period_date_from: this.$data.date_range_selected[0],
        period_date_to: this.$data.date_range_selected[1],
        with_timesheet: '1',
        filter_draft: '1',
      })
      .finally(() =>{
        this.showLoader = false
      });
    },
    getDriverFullName: function(shift) {
      if (shift.status_assigned == STATUS_FREE) { // !driver
        return 'Open shift';
      }

      let driver = _.find(this.driver_list, p => p.id == shift.driver_id);
      if (!driver) {
        return '-';
      }

      return driver.full_name;
    },
    getDriverPhone: function(shift) {
      if (moment(shift.period_date).format('YYYY-MM-DD') != moment().format('YYYY-MM-DD')) {
        return void 0;
      }

      let driver = _.find(this.driver_list, p => p.id == shift.driver_id);
      if (!driver) {
        return void 0;
      }

      return driver.phone;
    },
    onSelectInterval: function() {
      if (this.$data.interval_selected_id == INTERVAL_WEEK || this.$data.interval_selected_id == INTERVAL_TWO_WEEK || this.$data.interval_selected_id == INTERVAL_MONTH ) { // reset to the start of week, if changed from day
        let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        this.$data.date_range_selected = [date_to_shift.startOf('isoWeek').format("YYYY-MM-DD"), null];
      }

      if (this.$data.interval_selected_id == INTERVAL_DAY) { // reset to the current day, if changed from week
        let current_day = moment();
        // let date_to_shift_start = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        // let date_to_shift_end = moment(this.$data.date_range_selected[1], "YYYY-MM-DD");
        // if (date_to_shift_start < current_day && current_day < date_to_shift_end) {
          this.$data.date_range_selected = [current_day.format("YYYY-MM-DD"), null];
        // } else {
        //   this.$data.date_range_selected = [date_to_shift_start.format("YYYY-MM-DD"), null];
        // }
      }

      Vue.nextTick(() => {
        this.dateRangeSelect();
      });
    },
    onSelectRestaurantMobile: function(location_selected) {
      if (!location_selected) {
        this.restaurant_item_mobile_selected = void 0;
        return;
      }

      let result = void 0;

      switch(location_selected.type) {
        case TYPE_AREA:
          // filter by list of restaurants
          // result = _.filter(result, p => p.area_id == location_selected.id);
          break;
        case TYPE_RESTAURANT:
          result = _.find(this.restaurant_list, p => p.id == location_selected.id);
          break;
      }

      this.restaurant_item_mobile_selected = result;
      this.location_selected = location_selected;
    },
    onPreviosRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.subtract(1, 'days');
          break;
        case INTERVAL_WEEK:
          date_to_shift.subtract(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.subtract(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.subtract(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    onNextRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.add(1, 'days');
          break;
        case INTERVAL_WEEK:
          date_to_shift.add(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.add(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.add(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    onChangeDriver: function(driver) {
      if(driver.id == -1) { // all drivers
        Vue.nextTick(() => {
          this.$data.selected_driver = void 0;
        });
      } else {
        Vue.nextTick(() => {
          if (this.$data.selected_driver && this.$data.selected_driver.id == driver.id) { // self clicked deselect
            this.$data.selected_driver = void 0;
            return; // exit
          }

          this.$data.selected_driver = driver;
        });
      }
    },
    removeShift: function (shift) {
      if(!confirm('Remove shift ' + shift.period_date + '?')) {
        return; // exit
      }

      shift.localLoading = true;
      this.$store.dispatch('removeShift', shift).then(() => {
      }).finally(() => {
        shift.localLoading = false;
      });

      this.$data.shift_to_copy = void 0;
    },
    copyShift: function (shift) {
      this.$data.shift_to_copy = shift;
    },
    pasteShift: function (restaurant_item, period_item) {
      /**
       * if paste in weekday or from weekday or into another restaurant(area)
       *  then recalculate `cost_per_hour` and `cost_total`
       **/
      let shift_hours = this.getShiftHours(this.$data.shift_to_copy);

      //-- calc `cost_per_hour`
      let area_selected = _.find(this.area_list, p => p.id == restaurant_item.area_id);
      let cost_per_hour = restaurant_item.standard_pay ? restaurant_item.standard_pay : area_selected.standardPayRate;
      // check date is weekend, then get weekend rate
      let shift_date = moment(period_item.date, "YYYY-MM-DD");
      if(shift_date.isoWeekday() === 5 || shift_date.isoWeekday() === 6 || shift_date.isoWeekday() === 7) {
          cost_per_hour = restaurant_item.weekend_pay ? restaurant_item.weekend_pay : area_selected.weekendPayRate;
      }

      //-- calc `cost_total`
      let cost_total = (+cost_per_hour * shift_hours).toFixed(2);

      const newShift = {
        restaurant_id: restaurant_item.id, //!
        driver_id: this.$data.shift_to_copy.driver_id ? this.$data.shift_to_copy.driver_id : void 0,
        status: STATUS_NEW,
        status_assigned: STATUS_FREE,
        period_date: period_item.date, //!
        start_time: this.$data.shift_to_copy.start_time,
        finish_time: this.$data.shift_to_copy.finish_time,
        meal_time: 0,
        rest_time: 0,
        cost_per_hour: cost_per_hour, //!
        cost_total: cost_total, //!
        comment: this.$data.shift_to_copy.comment,
        cost_bonus: 0, // this.$data.shift_to_copy.cost_bonus,
        const_fuel_bonus: 0, // this.$data.shift_to_copy.const_fuel_bonus,
        cost_extra_bonus: 0, // this.$data.shift_to_copy.cost_extra_bonus,
        // created_at: void 0,
        // updated_at: void 0,
      };

      // -- check driver Unavailability before publish shifts
      if (newShift.driver_id) {
        let driver = _.find(this.driver_list, p => p.id == newShift.driver_id);
        let working_days = this.getDriverWorkingDay(driver, newShift.period_date);
        if (driver && !_.isEmpty(working_days)) {
          let is_holiday = false;
          let is_itersection_start_founded = false;
          let is_itersection_finish_founded = false;
          _.each(working_days, p => {
              if (is_holiday || is_itersection_start_founded || is_itersection_finish_founded) return;

              if (p.holiday == IS_HOLIDAY) {
                  is_holiday = true;
              }

              if (this.isTimeIntersects(p.start_at, p.stop_at, this.$data.start_time)) {
                  is_itersection_start_founded = true;
              }

              if (this.isTimeIntersects(p.start_at, p.stop_at, this.$data.finish_time)) {
                  is_itersection_finish_founded = true;
              }
          });

          if (is_holiday || !is_itersection_start_founded || !is_itersection_finish_founded) {
            let error_message = 'Driver '+ driver.full_name  +' unavailable at ' + newShift.period_date;

            if (!is_holiday) {
              let driver_working_time_labels = _.map(working_days, p => {
                  return moment(p.start_at, "HH:mm").format('HH:mm') + '-' + moment(p.stop_at, "HH:mm").format('HH:mm')
              });
              error_message = "\r\n" + 'Driver '+ driver.full_name  +' working time: ' + driver_working_time_labels.join(', ') + ' at ' + shift.period_date;
            }
            if (!confirm(error_message + "\r\n\r\n Paste Open shift?")) {
              return; // exit can't paste shift
            }
            newShift.driver_id = void 0; // become free shift
          }
        }
      }

      period_item.localLoading = true;
      this.localLoading = true;

      // if "Shift" buutton pressed then can paste multiplie
      let continue_copy = !window.event.shiftKey;

      this.$store.dispatch('createNewShift', newShift).then(() => {
        if (continue_copy) {
          this.$data.shift_to_copy = void 0;
        }
      }).finally(() => {
        period_item.localLoading = false;
        this.localLoading = false;
      });
    },
    changeShiftStatus: function(shift, status, options) {
      // -- check driver Unavailability before publish shifts
      if (shift.driver_id) {
        let driver = _.find(this.driver_list, p => p.id == shift.driver_id);
        let working_days = this.getDriverWorkingDay(driver, shift.period_date);
        if (driver && !_.isEmpty(working_days)) {
          let is_holiday = false;
          let is_itersection_start_founded = false;
          let is_itersection_finish_founded = false;
          _.each(working_days, p => {
              if (is_holiday || is_itersection_start_founded || is_itersection_finish_founded) return;

              if (p.holiday == IS_HOLIDAY) {
                  is_holiday = true;
              }

              if (this.isTimeIntersects(p.start_at, p.stop_at, this.$data.start_time)) {
                  is_itersection_start_founded = true;
              }

              if (this.isTimeIntersects(p.start_at, p.stop_at, this.$data.finish_time)) {
                  is_itersection_finish_founded = true;
              }
          });

          if (is_holiday || !is_itersection_start_founded || !is_itersection_finish_founded) {
            let error_message = 'Driver '+ driver.full_name  +' unavailable at ' + shift.period_date;

            if (!is_holiday) {
              let driver_working_time_labels = _.map(working_days, p => {
                  return moment(p.start_at, "HH:mm").format('HH:mm') + '-' + moment(p.stop_at, "HH:mm").format('HH:mm')
              });
              error_message = "\r\n" + 'Driver '+ driver.full_name  +' working time: ' + driver_working_time_labels.join(', ') + ' at ' + shift.period_date;
            }
            alert(error_message);
            return; // exit can't publish shift
          }
        }
      }

      shift.status = status;
      this.localLoading = true;
      shift.localLoading = true;

      // notifiy driver marker
      shift.push_drivers = void 0; // clear previos state
      if (options && options.push_drivers) {
        shift.push_drivers = options.push_drivers
      }

      this.$store.dispatch('editShift', shift).then(() => {
      }).finally(() => {
        this.localLoading = false;
        shift.localLoading = false;
      });

      this.$data.shift_to_copy = void 0;
    },
    publishPeriodShifts(options) {
      let unpublished_shifts = _.filter(this.shiftListDriverSearched, p => p.status == STATUS_NEW);

      // -- check driver Unavailability before publish shifts
      let unvailable_driver_errors = [];
      let unpublished_shifts_correct = _.filter(unpublished_shifts, shift => {
        if (!shift.driver_id) {
          return true; // no driver - allow publish
        }

        // check drivers working time intersections
        let driver = _.find(this.driver_list, p => p.id == shift.driver_id);
        if (!driver) {
          return true; // no driver - allow publish
        }

        let working_days = this.getDriverWorkingDay(driver, shift.period_date);
        if (_.isEmpty(working_days)) {
          return true;  // no driver working days - allow publish
        }

        let driver_working_time_labels = _.map(working_days, p => {
            return moment(p.start_at, "HH:mm").format('HH:mm') + '-' + moment(p.stop_at, "HH:mm").format('HH:mm')
        });

        let is_holiday = false;
        let is_itersection_start_founded = false;
        let is_itersection_finish_founded = false;
        _.each(working_days, p => {
            if (is_holiday || is_itersection_start_founded || is_itersection_finish_founded) return;

            if (p.holiday == IS_HOLIDAY) {
                is_holiday = true;
            }

            if (this.isTimeIntersects(p.start_at, p.stop_at, this.$data.start_time)) {
                is_itersection_start_founded = true;
            }

            if (this.isTimeIntersects(p.start_at, p.stop_at, this.$data.finish_time)) {
                is_itersection_finish_founded = true;
            }
        });

        if (is_holiday) {
          unvailable_driver_errors.push('Driver '+ driver.full_name  +' unavailable at ' + shift.period_date);
        } else if (!is_itersection_start_founded) {
          unvailable_driver_errors.push('Driver '+ driver.full_name  +' working time: ' + driver_working_time_labels.join(', ') + ' at ' + shift.period_date);
        } else if (!is_itersection_finish_founded){
          unvailable_driver_errors.push('Driver '+ driver.full_name  +' working time: ' + driver_working_time_labels.join(', ') + ' at ' + shift.period_date);
        }

        if (is_holiday || !is_itersection_start_founded || !is_itersection_finish_founded) {
          return false; // driver can't work disallow publish
        }

        return true; // driver can work allow publish
      });

      if (unvailable_driver_errors.length > 0) {
        let incorrect_count = unpublished_shifts.length - unpublished_shifts_correct.length;
        if (!confirm("Some driver unvalilable on published shifts("+ incorrect_count +"):\r\n" + unvailable_driver_errors.join("\r\n") + "\r\n\r\nSkip to publish incorrect shifts and publish correct shifts?")) {
          return; // exit
        }
      }

      if (unpublished_shifts_correct.length == 0) {
        alert('No more shifts to publish');
        return; // exit
      }

      this.localLoading = true;
      this.publishPeriodLoading = true;
      _.each(unpublished_shifts_correct, shift => {
        shift.localLoading = true;
      });

      this.$store.dispatch('publishShifts', {shifts: unpublished_shifts_correct, options}).then(() => {
      }).finally(() => {
        this.localLoading = false;
        this.publishPeriodLoading = false;
        _.each(unpublished_shifts_correct, shift => {
          shift.localLoading = false;
        });
      });

      this.$data.shift_to_copy = void 0;
    },
    unpublishPeriodShifts(options) {
      let published_shifts = _.filter(this.shiftListDriverSearched, p => p.status == STATUS_PUBLICATED);
      this.localLoading = true;
      this.publishPeriodLoading = true;
      _.each(published_shifts, shift => {
        shift.localLoading = true;
      });

      this.$store.dispatch('unpublishShifts', {shifts: published_shifts, options}).then(() => {
      }).finally(() => {
        this.localLoading = false;
        this.publishPeriodLoading = false;
        _.each(published_shifts, shift => {
          shift.localLoading = false;
        });
      });

      this.$data.shift_to_copy = void 0;
    },
    removePeriodShifts(options) {
      let unpublished_shifts = _.filter(this.shiftListDriverSearched, p => p.status == STATUS_NEW);
      this.localLoading = true;
      this.publishPeriodLoading = true;
      _.each(unpublished_shifts, shift => {
        shift.localLoading = true;
      });

      this.$store.dispatch('removeShifts', {shifts: unpublished_shifts, options}).then(() => {
      }).finally(() => {
        this.localLoading = false;
        this.publishPeriodLoading = false;
        _.each(unpublished_shifts, shift => {
          shift.localLoading = false;
        });
      });

      this.$data.shift_to_copy = void 0;
    },
    getDriverWorkingDay(driver, period_date) {
        // try to find override dates
        let items = _.filter(driver.actual_override_working_time, p => p.period_date == period_date);
        if (items.length > 0) {
            return items;
        }

        let week_day = moment(period_date, "YYYY-MM-DD").isoWeekday() - 1;
        items = _.filter(driver.default_working_time, p => p.week_day == week_day);

        return items;
    },
    // -- helpers:
    dayToRange: function(date, interval_id) {
        return DATE_RANGE_HELPERS.dayToRange(date, interval_id)
    },
    dateRangeText: function (date_range_selected) {
        return DATE_RANGE_HELPERS.dateRangeText(date_range_selected)
    },
    getShiftHours: function(shift_item) {
      //-- calc `shift_hours`
      let finish_time = moment(shift_item.finish_time, "HH:mm");
      let start_time = moment(shift_item.start_time, "HH:mm");
      if (!finish_time.isValid() || !start_time.isValid()) {
          return 0;
      }

      if (shift_item.finish_time < shift_item.start_time) {
        finish_time.add(1, 'days');
      }

      return ( (finish_time - start_time) / (60 * 1000) ) / 60;
    },
    isTimeIntersects(start_at, stop_at, check) {
      if (!check) {
        return false;
      }

      if (moment(start_at, "HH:mm").format('HH:mm') < moment(stop_at, "HH:mm").format('HH:mm')) {
        return moment(start_at, "HH:mm").format('HH:mm') <= moment(check, "HH:mm").format('HH:mm')
          && moment(stop_at, "HH:mm").format('HH:mm') >= moment(check, "HH:mm").format('HH:mm');
      } else {
        return moment(start_at, "HH:mm").format('HH:mm') <= moment(check, "HH:mm").format('HH:mm');
      }
    },
    onScrollPanel(e) {
      this.bodyScrollLeft = e.target.scrollLeft;
    }
  },
  filters: {
      formatFloat: function (num) {
        return Number(num).toFixed(2);
      },
      formatHours: function (num) {
        return Number(num).toFixed(1);
      },
      headerData: function (date) {
        return moment(date, "YYYY-MM-DD").format('ddd, MMM Do');
      },
      moment: function (date) {
        return moment(date, "YYYY-MM-DD").format('MMM Do');
      },
      formatTime: function (time) {
        return moment(time, "HH:mm").format('HH:mm');
      },
    },
}
</script>

<style scoped>
  .select-drop-item-group__area {
    background: #e0e0e0;
  }

  .select-drop-item-sub_restaurant {
    padding-left: 16px;
  }
  .driver-list_leftpanel {
    padding-left: 0px;
    padding-right: 0px;
  }

  .driver-profile_icon {
    margin-right: 8px !important;
  }

  .driver-photo_src {
    max-width: 36px;
    max-height: 24px;
  }

  .header-btn-panel-mobile {
    padding: 6px 0 6px;
  }

  .menu-date__picker-mobile {
    margin-bottom: 6px;
  }

  .right-panel-calendar-mobile {
    width: 100%;
  }
</style>

<style>
  /* restore overloaded style */
  .multiselect__content-wrapper > ul.multiselect__content {
    padding-left: 0px;
  }
  .shift-total_value {
    font-weight: bold;
  }

  .header-btn-panel {
    min-width: 1200px;
  }

  .right-panel-calendar {
    width: 100%;
    overflow-x:auto;
    margin-left: 256px;
    margin-top:93px;
  }

  .v-card-header-day {
    min-width:1400px;
  }

  .v-card-header-week {
    min-width:1400px;
  }

  .v-card-day {
    min-width:0px;
  }

  .v-card-week {
    min-width:1400px;
  }

  .v-card-header-two-week,
  .v-card-two-week {
    min-width:2800px;
  }

  .v-card-header-month,
  .v-card-month {
    min-width:6200px;
  }

@media (min-width: 1600px)
  {
    .v-card-header-day {
    min-width:calc(84vw);
  }

  .v-card-header-week {
    min-width:calc(84vw);
  }
}
</style>
